<template>
  <v-container
    fluid
    class="mt-2"
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <pageHeader :title="title" />

    <ImportBookmark />

    <v-card class="mt-6">
      <v-card-title>
        <v-icon left>mdi-help-circle</v-icon>
        Need Help?
      </v-card-title>
      <v-card-text>
        <p class="mb-3">
          Learn how to export bookmarks from your browser and import them into
          LinkBook.io, or export LinkBook.io bookmarks back to your browser.
        </p>
        <v-btn color="info" outlined to="/bookmark-guide">
          <v-icon left>mdi-book-open-variant</v-icon>
          View Complete Guide
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ImportBookmark from '@/components/utils/ImportBookmark'
import pageHeader from '@/components/layout/PageHeader'

export default {
  name: 'BookmarkImport',
  metaInfo: {
    title: 'Import Bookmarks | Transfer Browser Bookmarks',
    titleTemplate: '%s - LinkBook.io',
    meta: [
      {
        name: 'description',
        content:
          'Import bookmarks from any browser into LinkBook.io. Upload your HTML bookmark file and automatically organise bookmarks by domain.'
      },
      {
        name: 'keywords',
        content:
          'import bookmarks, upload bookmarks, transfer bookmarks, browser bookmark import, HTML bookmark file'
      }
    ]
  },
  components: {
    ImportBookmark,
    pageHeader
  },
  data() {
    return {
      title: 'Import your bookmarks'
    }
  }
}
</script>
